<div class="filter">
<!--  <div class="labelWrapper">-->
<!--    <span class="legendText" title="Select date range">Select date range</span>-->
<!--  </div>-->
  <div class="rangeContainer">
    <input autocomplete="off" class="from datepicker hasDatepicker" id="datepickerFrom" name="datepickerFrom"
           placeholder="From" type="text" value="" [ngClass]="{'invalid-date': !validFromDate}"
           [(ngModel)]="dateRange.ngbFromDate" ngbDatepicker (click)= "dtpFromDate.toggle()" (focusout)="focusOut()"
           (mousedown)="mouseDownOnFromDate()" (keyup)="keyUpOnFromDate()" (ngModelChange)="onFromDateChange()" #dtpFromDate="ngbDatepicker">
<!--    <div class="input-group-append" style="visibility: hidden; position: absolute;">-->
<!--      <button class="btn btn-outline-secondary calendar" (click)="dtpFromDate.toggle()" type="button"></button>-->
<!--    </div>-->
    <input autocomplete="off" class="to datepicker hasDatepicker" id="datepickerTo" name="datepickerTo"
           placeholder="To" type="text" value="" [ngClass]="{'invalid-date': !validToDate}" [disabled]="restricted"
           [(ngModel)]="dateRange.ngbToDate" ngbDatepicker (click)= "dtpToDate.toggle()" (focusin)="mouseDownOnToDate()" (focusout)="focusOut()"
           (mousedown)="mouseDownOnToDate()" (keyup)="keyUpOnToDate()" (ngModelChange)="onToDateChange()" #dtpToDate="ngbDatepicker">
<!--    <div class="input-group-append" style="visibility: hidden; position: absolute;">-->
<!--      <button class="btn btn-outline-secondary calendar" (click)="dtpToDate.toggle()" type="button"></button>-->
<!--    </div>-->
  </div>
</div>
